import { startCase, capitalize } from 'lodash';

export const transformErrors = (errors) => {
  console.log(Object.entries(errors));

  return Object.entries(errors).map(([key, values]) => values[0].replace(key, capitalize(startCase(key))));
};
